import {
    IoCheckmarkCircleOutline,
    IoInformationCircleOutline,
} from "react-icons/io5";

import { PiWarningOctagon } from "react-icons/pi";

import { MdCancel } from "react-icons/md";
import cn from "../../../lib/cn";

const PaymentStatus = ({ status, statusType }) => {
    return (
        <div
            className={cn(
                "flex gap-0.5 items-center bg-gray-100 text-xs px-0.8 py-0.2 rounded-2 font-vietnam font-thin capitalize",
                {
                    "bg-blue bg-opacity-10 text-blue": statusType === "info",
                    "bg-orange bg-opacity-10 text-orange":
                        statusType === "warn",
                    "bg-green bg-opacity-10 text-green-200":
                        statusType === "success",
                    "bg-red bg-opacity-10 text-red": statusType === "failed",
                }
            )}
        >
            {statusType === "success" ? (
                <IoCheckmarkCircleOutline className="text-xl" />
            ) : statusType === "warn" ? (
                <PiWarningOctagon className="text-xl" />
            ) : statusType === "failed" ? (
                <MdCancel className="text-xl" />
            ) : (
                <IoInformationCircleOutline className="text-xl" />
            )}
            {status}
        </div>
    );
};

export default PaymentStatus;
